import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Container, Row, Col, Spinner, Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import "./EmployeeResults.css";
import { fetchActiveEvent, fetchCompletedEvent, fetchPreviousEventResult, fetchResultDetails } from '../Services/Employees';

const EmployeeResults = () => {
  const [results, setResults] = useState([]);
  const [previousResults, setPreviousResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [responseMsg, setResponseMsg] = useState('');
  const [modal, setModal] = useState(false);
  const [result, setResultModal] = useState(false);
  const [completedEvent, setCompleteEvent] = useState([]);
  const [eventValue, setEventValue] = useState('');

  //const [degrowthLengthImg, setDegrowthLengthImg] = useState([])

  const toggle = () => setModal(!modal);

  const Resulttoggle = () => setResultModal(!result);

  useEffect(() => {
    fetchResultDetails().then((response) => {
      setResults(response.data.data);
      console.log(results);
    }, (error) => {
      console.log(error);
      setResponseMsg(error.response.data.message);
    });
  }, []);

  
//   const deleteImgfunc = useCallback((value: String) => {
//     // If you want to add to array
//      setDegrowthLengthImg(deg => [...deg, value]);
// }, []);

  const showPreviousEvent = () => {
    fetchCompletedEvent().then((response) => {
      setCompleteEvent(response.data);
    },
      (error) => {
      });
    setModal(!modal);
  };

  const fetchPreviousResultDetails = () => {
    const data={eventName:eventValue}
    fetchPreviousEventResult(data).then((response) => {
      setResultModal(!result)
      setPreviousResults(response.data.data);
      console.log(response);
    },
      (error) => {
        console.log(error);
      });
    setModal(!modal);
  };

  const toggleTooltip = (id) => {
    setTooltipOpen({ ...tooltipOpen, [id]: !tooltipOpen[id] });
  };

  return (
    
    <div className="card border-0" style={{ background: "white" }}>
    {/* <div style={{ margin: "2%", padding: "2%", backgroundColor: "#ecf0f1", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", borderRadius: "8px" }}>
      <div style={{ minHeight: "245px" }}> */}

<div className="card-header " style={{backgroundColor:"transparent"}} >
          <h5 className="card-title text-center mb-0 py-2">Employee Results</h5>
        </div>
        <div className="card-body">
        {responseMsg === '' ? (
          <div>
            {/* <div className="header text-center p-3 mb-4">
              <h5>Employee Results</h5>
            </div> */}
            { loading ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : (
              <Table hover className="results-table">
                <thead>
                  <tr>
                    <th>Paper Name</th>
                    {/* <th>Total Marks</th> */}
                    {/* <th>Marks Obtained</th> */}
                    <th>Status</th>
                    <th>Progress</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((result) => {
                    const statusIcon = result.status === 'Pass' ? (
                      <FontAwesomeIcon icon={faCheckCircle} color="green" id={`status-${result.id}`} />
                    ) : (
                      <FontAwesomeIcon icon={faExclamationCircle} color="red" id={`status-${result.id}`} />
                    );
                    return (
                      <tr key={result.id}>
                        <td>{result.course}</td>
                        {/* <td>{result.totalMarks}</td>
                        <td>{result.marksObtained}</td> */}
                        <td>{result.status}</td>
                        <td>
                          {statusIcon}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </div>
        ) : (
          
            <div className="row">
              <div className="header text-center p-3 mb-4">
              <h5 className='text-center' style={{ marginTop: "9%", color: '#151e6bdb' }}>{responseMsg}</h5>
                {/* <h5>{responseMsg}</h5> */}
              </div>
            </div>
          
        )}
        </div>
        <div className='text-center pb-3'>
          <button type="button" className="btn btn-primary" onClick={showPreviousEvent}>Click Here to see previous Result</button>
        </div>
        <Modal isOpen={modal} toggle={toggle} centered backdrop='static' >
          <ModalHeader toggle={toggle}>
            Select Event To See Result
          </ModalHeader>
          <ModalBody className='py-5'>
            <select className="form-select" onChange={event => setEventValue(event.target.value)}aria-label="Default select example">
              <option selected>Select Event</option>
              {completedEvent.map((result, index) => (
                <option key={index} value={result}>{result}</option>
              ))}
            </select>
          </ModalBody>
          <ModalFooter className='justify-content-around'>
            <Button color="primary" onClick={fetchPreviousResultDetails}>
              Submit
            </Button>{' '}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={result} centered backdrop='static'>
          <ModalHeader>
          RESULT
          </ModalHeader>
          <ModalBody>
          <Table hover responsive className="results-table">
                <thead>
                  <tr>
                    <th>Paper Name</th>
                    <th>Total Marks</th>
                    <th>Marks Obtained</th>
                    <th>Status</th>
                    <th>Progress</th>
                  </tr>
                </thead>
                <tbody>
                  {previousResults.map((result) => {
                    const statusIcon = result.status === 'Pass' ? (
                      <FontAwesomeIcon icon={faCheckCircle} color="green" id={`status-${result.id}`} />
                    ) : (
                      <FontAwesomeIcon icon={faExclamationCircle} color="red" id={`status-${result.id}`} />
                    );
                    return (
                      <tr key={result.id}>
                        <td>{result.course}</td>
                        <td>{result.totalMarks}</td>
                        <td>{result.marksObtained}</td>
                        <td>{result.status}</td>
                        <td>
                          {statusIcon}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
          </ModalBody>
          <ModalFooter>
            {/* <Button color="primary" onClick={fetchPreviousResultDetails}>
              Submit
            </Button>{' '} */}
            <Button color="secondary" onClick={Resulttoggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {/* </div>
        </div> */}
      
      
      </div>
  
  );
};

export default EmployeeResults;
